import { render, staticRenderFns } from "./MarsIndex.vue?vue&type=template&id=1f26d256&scoped=true&"
import script from "./MarsIndex.vue?vue&type=script&lang=js&"
export * from "./MarsIndex.vue?vue&type=script&lang=js&"
import style0 from "./MarsIndex.vue?vue&type=style&index=0&id=1f26d256&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f26d256",
  null
  
)

export default component.exports